import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { getAllMonthlyRedux } from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./refund.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
      category: "1688-orders",
    };
  }

  componentDidMount = async () => {
    this.props.getAllMonthlyRedux("REFUND", "REFUND PURPOSE");
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  clickActive = (event, category) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
    this.setState({
      category: category,
      subCategory: "",
      note: "",
      amount: "",
    });
  };

  render() {
    const { open } = this.state;
    let months = this.props.allMonths;

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Refunds" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid rf-page kd-cash kd-st--rose">
          <div className="row">
            <div className="col-sm-12">
              <div className="card rf-card">
                <div className="card-header rf-card-header">
                  <h5 className="rf-card-title">
                    <i className="icofont-list rf-card-icon"></i>
                    Refunds
                  </h5>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={months}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.expenses.monthly,
  };
};

export default connect(mapStateToProps, {
  getAllMonthlyRedux,
})(MonthlyExpense);
